import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { Logger } from "../utils/logger";
import { getAttributeSubmitValue } from "./attribute-data-util";
import { datadogRum } from '@datadog/browser-rum';
import { AttributeFormState } from "../types/state/attribute-form-state";

type SMSRequest = {
    asi: string;
    url: string;
	language: LocaleTypes;
    attrid?: string | number;
    emailattrid?: string | number;
    email?: string | number;
    dialcode?: string | number;
    telephone?: string | number;
}

export const buildSMSRequestParams = (
	attributeData: Array<AttributeFormState>,
	asi: string,
	contextPath: string,
	language: LocaleTypes
) => {
	let foundPhone: AttributeFormState = null;
	let foundEmail: AttributeFormState = null;
	const url = `${contextPath}/doc/sendasyncsms.max`;
	const smsReq: SMSRequest = {
		asi,
		url,
		language
	};
	const phoneAttribute = attributeData.find((attribute) => attribute.type === 'InternationalTelephone');
	const emailAttribute = attributeData.find((attribute) => attribute.type === 'Email');

	if (phoneAttribute) {
		foundPhone = phoneAttribute;
	}

	if (emailAttribute) {
		foundEmail = emailAttribute;
	}

	if (foundPhone == null) {
		Logger.error('ERROR No telephone attribute found');
		const error = new Error('ERROR No telephone attribute found');
		datadogRum.addError(error);
		return false;
	}

	const phoneData = getAttributeSubmitValue(foundPhone); // foundPhone.getData();

	if (foundPhone.status === 'picker') {
		//this is in picker status, send attributeid instead
		smsReq.attrid = phoneData.data.id;
	} else if (foundPhone.status === 'pass') {
		//this is in picker status, send attributeid instead
		smsReq.attrid = phoneData.data.id;
	} else {
		smsReq.dialcode = phoneData.data.dialCode;
		smsReq.telephone = phoneData.data.telephone;
	}
	Logger.info('Built Async request with phone data', smsReq);

	if (foundEmail !== null) {
		const emailData = getAttributeSubmitValue(foundEmail);
		if (foundEmail.status === 'picker') {
			//this is in picker status, send attributeid instead
			smsReq.emailattrid = emailData.data.id;
		} else if (foundEmail.status === 'pass') {
			//this is in picker status, send attributeid instead
			smsReq.emailattrid = emailData.data.id;
		} else {
			smsReq.email = emailData.data.email;
		}
		Logger.info('Built Async request with email data', smsReq);
	}

	return smsReq;
}